import { SchoolYear } from '../types';

const schoolId = '750e8400-e29b-41d4-a716-446655440001';

export const mockSchoolYears: SchoolYear[] = [
  {
    id: '1050e8400-e29b-41d4-a716-446655440001',
    name: '2023-2024',
    startDate: new Date('2023-08-15'),
    endDate: new Date('2024-06-15'),
    isActive: false,
    schoolId,
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440002',
    name: '2024-2025',
    startDate: new Date('2024-08-15'),
    endDate: new Date('2025-06-15'),
    isActive: true,
    schoolId,
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440003',
    name: 'Summer 2025',
    startDate: new Date('2025-06-16'),
    endDate: new Date('2025-08-14'),
    isActive: false,
    schoolId,
  },
  {
    id: '1050e8400-e29b-41d4-a716-446655440004',
    name: '2025-2026',
    startDate: new Date('2025-08-15'),
    endDate: new Date('2026-06-15'),
    isActive: false,
    schoolId,
  },
];
